module.exports = __webpack_public_path__ + "img/222-a0027b.png";